import React from 'react'
import PropTypes from 'prop-types'
import { capitalize } from '@leverege/string-util'
import classnames from 'classnames'
import { Selector } from '@leverege/ui-elements';
import { TextInput, Text, Flex, LabelGroup, Section, Icon } from '~/views';

import { types } from './Factory'
import style from './style.css'

export default class BaseTimerEditor extends React.Component {

  static currentContextKeys = [
    'projectId', 'systemId', 'scriptId', 'deviceId'
  ]

  static propTypes = {
    timer : PropTypes.object,
    currentContext : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired
  }

  static getDisplayTypeDropdown( timerObj, onChange ) {
    return (
      <LabelGroup>
        <label>Type</label>
        <Selector
          valueKey="value"
          nameKey="value"
          values={types}
          value={timerObj.type}
          onChange={( value ) => { onChange( 'timer/type', value.value, false ); }} />
      </LabelGroup>
    )
  }

  static getDisplayContext( timer, currentContext ) {
    const labels = []
    BaseTimerEditor.currentContextKeys.forEach( ( key ) => {
      if ( !currentContext[key] ) {
        labels.push(
          <LabelGroup id={key} key={key}>
            <label>{capitalize( key )}</label>
            <Text type="dim" text={timer[key] || 'N/A'} />
          </LabelGroup>
        )
      }
    } )

    return (
      <Section title="Timer Context" titleOnTop>
        <Flex variant="vSpace" align="stretch" direction="column">
          { labels }
        </Flex>
      </Section>
    )
  }

  constructor( props ) {
    super( props )
  }

  changePath = ( path, value, err ) => {
    if ( err ) {
      console.log( `error setting ${path} to ${value}`, err )
      this.props.onError( path, value, err )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      
      this.props.onChange( { target : this.props.timer, path, value } );
    }
  }

  getTimerIcon( timerObj ) {
    switch ( timerObj && timerObj.type ) {
      case 'once':
        return null
      case 'repeating':
        return (
          <div className={classnames( style.iconHolder )} style={{ width : '40px', height : '40px' }}>
            <Icon className={style.icon} fontIcon="fa fa-repeat" />
          </div>
        )
      case 'scheduled':
        return (
          <div className={classnames( style.iconHolder )} style={{ width : '40px', height : '40px' }}>
            <Icon className={style.icon} fontIcon="fa fa-calendar" />
          </div>
        )
      default:
        return null
    }
  }

  render() {
    const { timer, currentContext } = this.props
    const timerObj = timer.timer
    const icon = this.getTimerIcon( timerObj )

    return (
      <Section title={timer.name} subtitle={timer.id} titleOnTop right={icon}>
        <Flex variant="vSpace" align="stretch" direction="column">
          <LabelGroup>
            <label>Name</label>
            <TextInput
              value={timer.name} 
              changeOnReturn
              size={10}
              onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
          </LabelGroup>
          <LabelGroup>
            <label>Description</label>
            <TextInput
              value={timer.description}
              changeOnReturn
              size={10}
              onChange={( v, err ) => { this.changePath( 'description', v, err ) }} />
          </LabelGroup>
        </Flex>
      </Section>
    )
  }

}
